// Every rate range on the screens reads the stored per-list figures — min, max and avg, personal rows
// included — instead of a browser-side min/max over role rows, so the three always agree with the catalogue.

export const trimNumber = (value: string | number): string => String(Math.round(Number(value) * 100) / 100);

export const formatRateRange = (
    minHourlyPrice: string | number | null | undefined,
    maxHourlyPrice: string | number | null | undefined,
    avgHourlyPrice: string | number | null | undefined,
    currencyTypeCode?: string | null
): string => {
    if (minHourlyPrice == null || maxHourlyPrice == null) {
        return '';
    }
    const currency = currencyTypeCode ? `${currencyTypeCode} ` : '';
    const range = `${trimNumber(minHourlyPrice)}–${trimNumber(maxHourlyPrice)}`;
    return avgHourlyPrice == null ? `${currency}${range}` : `${currency}${range} (avg ${trimNumber(avgHourlyPrice)})`;
};
